// extracted by mini-css-extract-plugin
export var container = "styles-module--container--a8011";
export var desktop = "1340px";
export var disclaimer = "styles-module--disclaimer--dfeb5";
export var feeItems = "styles-module--feeItems--bd71d";
export var fees = "styles-module--fees--b19b8";
export var giant = "2200px";
export var inclusion = "styles-module--inclusion--01ed3";
export var inclusionList = "styles-module--inclusionList--af8d4";
export var inclusions = "styles-module--inclusions--a3ca5";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var showMoreButton = "styles-module--showMoreButton--8e9e9";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tableHeadings = "styles-module--tableHeadings--122e3";
export var tablet = "769px";
export var title = "styles-module--title--6f093";